import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/page/Home'
import NewsList from '@/page/NewsList'
import NewsContent from '@/page/NewsContent'

Vue.use(VueRouter)
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/news/:id',
      name: 'News',
      component: NewsList
    },
    {
      path: '/content/:id',
      name: 'Content',
      component: NewsContent
    }
  ],
  // 以下用于路由跳转 页面保持在顶部
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }

})




// WEBPACK FOOTER //
// ./src/router/index.js